module.exports = __webpack_public_path__ + "static/img/剪纸4.afa9d92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/剪纸4.svg
// module id = eX0G
// module chunks = 2